import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import fact1 from "../../images/Facts/fact1.svg";
import fact2 from "../../images/Facts/fact2.svg";
import fact3 from "../../images/Facts/fact3.svg";
import fact4 from "../../images/Facts/fact4.svg";
// import fact111 from "../../images/Facts/fact111.svg";
// import fact222 from "../../images/Facts/fact222.svg";
// import fact333 from "../../images/Facts/fact333.svg";
import fact55 from "../../images/Facts/fact55.svg";
import fact66 from "../../images/Facts/fact66.svg";
import fact77 from "../../images/Facts/fact77.svg";

// import ScrollButtom from "../ScrollButtom";

const Facts = () => {
  // const refContainer = useRef();

  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  const [refFact2, refFact2InView] = useInView();
  const [refFact2isVisible, setrefFact2IsVisible] = useState(false);
  useEffect(() => {
    if (refFact2InView && !refFact2isVisible) {
      setrefFact2IsVisible(true);
    } else if (!refFact2InView && refFact2isVisible) {
      setrefFact2IsVisible(false);
    }
  }, [refFact2isVisible, refFact2InView]);

  // const [refFact3, refFact3InView] = useInView();
  // const [refFact3isVisible, setrefFact3IsVisible] = useState(false);
  // useEffect(() => {
  //   if (refFact3InView && !refFact3isVisible) {
  //     setrefFact3IsVisible(true);
  //   } else if (!refFact3InView && refFact3isVisible) {
  //     setrefFact3IsVisible(false);
  //   }
  // }, [refFact3isVisible, refFact3InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row-reverse">
        <div className="stickyRowHeaders col-lg-4 col-12 d-flex align-items-center justify-content-center  bg-color-gr">
          <div className="d-lg-none d-inline">
            <div>Digikala at a Glance</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-200, 100]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Digikala at a Glance</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-0 bg-color-w py-4">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center px-lg-5 py-4"
                : "fade-in-section row m-0 text-center px-lg-4 py-4"
            }
          >
            <div className="col-6 col-lg-3 px-3">
              <div>
                <img className="factsA" src={fact1} alt="Direct Employee" />
              </div>
              <div className="h50p radius4 bg-dk-gr d-flex justify-content-center align-items-center">
                <div className="FactsNumbersFacts">+8,700</div>
              </div>
              <div className="h40p d-flex justify-content-center align-items-center">
                <div className="FactsDescFacts">Direct Employees</div>
              </div>
            </div>
            <div className="col-6 col-lg-3 px-3">
              <div>
                <img className="factsA" src={fact2} alt="Stock Keeping Units" />
              </div>
              <div className="h50p radius4 bg-dk-gr d-flex justify-content-center align-items-center">
                <div className="FactsNumbersFacts">+7,500,000</div>
              </div>
              <div className="h40p d-flex justify-content-center align-items-center">
                <div className="FactsDescFacts">SKUs</div>
              </div>
            </div>
            <div className="col-6 col-lg-3 px-3">
              <div>
                <img className="factsA" src={fact3} alt="Sellers" />
              </div>
              <div className="h50p radius4 bg-dk-gr d-flex justify-content-center align-items-center">
                <div className="FactsNumbersFacts">+249,000</div>
              </div>
              <div className="h40p d-flex justify-content-center align-items-center">
                <div className="FactsDescFacts">Sellers</div>
              </div>
            </div>

            <div className="col-6 col-lg-3 px-3">
              <div>
                <img
                  className="factsA"
                  src={fact4}
                  alt=" Monthly Unique Visitors"
                />
              </div>
              <div className="h50p radius4 bg-dk-gr d-flex justify-content-center align-items-center">
                <div className="FactsNumbersFacts">+39,500,000</div>
              </div>
              <div className="h40p d-flex justify-content-center align-items-center">
                <div className="FactsDescFacts">Monthly Unique Visitors</div>
              </div>
            </div>
          </div>

          <div
            ref={refFact2}
            className={
              refFact2isVisible
                ? "fade-in-section is-visible row mx-0 px-2 text-center mb-3 py-4"
                : "fade-in-section row mx-0 px-2 text-center py-4"
            }
          >
            <div className="col-4">
              <div>
                <img
                  className="factsC"
                  src={fact55}
                  alt="Daily Fulfillment Capacity"
                />
              </div>
              <div>
                <div className="FactsNumbersFacts">+960,000</div>
              </div>
              <div>
                <div className="FactsDescFacts">Daily Fulfillment Capacity</div>
              </div>
            </div>
            <div className="col-4">
              <div>
                <img className="factsC" src={fact66} alt="" />
              </div>
              <div>
                <div className="FactsNumbersFacts">+7,600,000</div>
              </div>
              <div>
                <div className="FactsDescFacts">Warehouse Capacity</div>
              </div>
            </div>
            <div className="col-4">
              <div>
                <img className="factsC" src={fact77} alt="" />
              </div>
              <div>
                <div className="FactsNumbersFacts">126</div>
              </div>
              <div>
                <div className="FactsDescFacts">Infrastructure Centers</div>
              </div>
            </div>
          </div>

          {/* <div
            ref={refFact3}
            className={
              refFact3isVisible
                ? "fade-in-section is-visible row px-2 mx-auto py-5"
                : "fade-in-section row px-2 mx-auto py-5"
            }
          >
            <div className="row d-flex justify-content-center align-items-center py-2">
              <div className="col-4 col-lg-6 text-end">
                <img className="factsB" src={fact111} alt="Sessions" />
              </div>
              <div className="col-8 col-lg-6">
                <div className="row">
                  <div className="FactsNumbersFacts">12,884,004</div>
                </div>
                <div className="row">
                  <div className="FactsDescFacts">Website/App Sessions</div>
                </div>
              </div>
            </div>

            <div className="row d-flex justify-content-center align-items-center py-2">
              <div className="col-4 col-lg-6 text-end">
                <img className="factsB" src={fact333} alt="Session Duration" />
              </div>
              <div className="col-8 col-lg-6">
                <div className="row">
                  <div className="FactsNumbersFacts">6 min. and 56 sec.</div>
                </div>
                <div className="row">
                  <div className="FactsDescFacts">Average Session Duration</div>
                </div>
              </div>
            </div>

            <div className="row  d-flex justify-content-center align-items-center py-2">
              <div className="col-4 col-lg-6 text-end">
                <img className="factsB" src={fact222} alt="Items Sold" />
              </div>
              <div className="col-8 col-lg-6">
                <div className="row">
                  <div className="FactsNumbersFacts">1,267,206</div>
                </div>
                <div className="row">
                  <div className="FactsDescFacts">Items Sold</div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* <ScrollButtom refContainer={refContainer} /> */}
    </div>
  );
};

export default Facts;
